import pLimit, { LimitFunction } from "p-limit";

const DEFAULT_CONCURRENCY_PER_ENDPOINT = 5;

// Map of endpoint path -> p-limit instance
const endpointLimiters = new Map<string, LimitFunction>();

function normalizeEndpoint(url: string): string {
  // Remove query parameters
  const pathOnly = url.split("?")[0];

  // Replace UUIDs (8-4-4-4-12 format)
  let normalized = pathOnly.replace(
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
    ":id"
  );

  // Replace numeric IDs in path segments
  normalized = normalized.replace(/\/\d+(?=\/|$)/g, "/:id");

  // Replace Shopify-style GIDs (gid://shopify/Product/123456)
  normalized = normalized.replace(/gid:\/\/[^/]+\/[^/]+\/\d+/g, ":gid");

  return normalized;
}

function getLimiter(endpoint: string): LimitFunction {
  let limiter = endpointLimiters.get(endpoint);
  if (!limiter) {
    limiter = pLimit(DEFAULT_CONCURRENCY_PER_ENDPOINT);
    endpointLimiters.set(endpoint, limiter);
  }
  return limiter;
}

export async function withRateLimit<T>(
  url: string,
  requestFn: () => Promise<T>
): Promise<T> {
  if (import.meta.env.VITE_RUNNING_LOCAL === "true") {
    const endpoint = normalizeEndpoint(url);
    const limiter = getLimiter(endpoint);

    return limiter(requestFn);
  }

  return requestFn();
}
